import { PRODUCT_TYPES } from '~/lib/constants'

import { usePackProductsProvider } from '~/providers/PackProductsProvider'
import { useUserSelectionProvider } from '~/providers/UserSelectionProvider'

export function useGetStateInformationsFromUserSelection() {
  const { data } = usePackProductsProvider()
  const { userSelection: selection } = useUserSelectionProvider()
  const activeTabIndex = selection?.findIndex((tab) => tab.isActive)
  const activeTab = selection?.[activeTabIndex]
  const activeProductId = activeTab?.productId
  const activeTabAvailableProducts = data?.[activeTabIndex]
  const variantId = activeTab?.variantId
  const product =
    data[activeTabIndex]?.find(
      ({ shopifyId }) => shopifyId === activeProductId,
    ) ?? null

  const products = data?.[activeTabIndex]
  const itemsToSelect = selection.length

  const variants = product?.variants
  const currentVariant = variants?.find((variant) => variant.id === variantId)

  const customizerProducts = product?.customizationProducts ?? []
  const customizerVariants = customizerProducts.map((product) => ({
    type: product.productType,
    variant: product.variants.find(
      (variant) => variant.id === activeTab[product.productType],
    ),
  }))
  const isBundle = Boolean(
    product?.labelCustomizationProducts?.length > 0 ||
      product?.customizationProducts?.length > 0,
  )
  const hasMultipleVariants = variants?.length > 1
  const labelProducts = product?.labelCustomizationProducts ?? []
  const isDisabledEngraving =
    (Boolean(
      customizerVariants?.find(({ variant }) => variant?.disablesEngraving),
    ) ||
      !labelProducts?.find(
        (product) => product?.productType === PRODUCT_TYPES.ENGRAVING,
      )) ??
    false

  const isDisabledLabelCustomization =
    (Boolean(
      customizerVariants?.find(({ variant }) => variant?.disablesLabel),
    ) ||
      !labelProducts?.find(
        (product) => product?.productType === PRODUCT_TYPES.LABEL,
      )) ??
    false

  const activeCustomization = product?.labelCustomizationProducts?.find(
    ({ id }) => Object.values(activeTab).includes(id),
  )
  const activeCustomizationVariant = activeCustomization?.variants.find(
    ({ id }) => Object.values(activeTab).includes(id),
  )

  const labelCustomizationVariant = activeTab?.labelCustomizationVariant ?? null

  return {
    data,
    activeTabIndex,
    activeTab,
    activeProductId,
    itemsToSelect,
    variantId,
    product,
    isBundle,
    products,
    variants,
    currentVariant,
    activeTabAvailableProducts,
    customizerProducts,
    customizerVariants,
    labelCustomizationVariant,
    labelProducts,
    isDisabledEngraving,
    isDisabledLabelCustomization,
    hasMultipleVariants,
    activeCustomization,
    activeCustomizationVariant,
  }
}
